import EditorPage from "./Index";

export const editorRoutes = (data) => [
  {
    path: "/admin/editor",
    title: "editor",
    layout: "admin",
    routeType: "admin",
    component: EditorPage,
  },
];
